module.exports = __webpack_public_path__ + "static/media/mini-SB.72b7a616.svg";